// extracted by mini-css-extract-plugin
export var boxItems = "_bf-1";
export var boxItemsLg = "_bf-2";
export var button = "_bf-7";
export var buttonLg = "_bf-8";
export var filterGroupBox = "_bf-0";
export var icon = "_bf-3";
export var iconSecondary = "_bf-6";
export var iconWrapper = "_bf-4";
export var iconWrapperLg = "_bf-5";